<!-- 确认认证接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "20190423090000",
            },
            responseCode: {
              "data": {},
              "message": "业务成功",
              "resultCode": 0,
              "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,获取支付配置信息列表(仅一点停)",
                t_url: this.commonUrls.test+"getPayChannelList",
                p_url: this.commonUrls.prod+"getPayChannelList",
                precondition: "无",
                fitSystem: "所有",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'payClient', info2: '是', info3: 'String', info4: '支付客户端' },
                        { info1: 'payOrigin', info2: '是', info3: 'String', info4: '支付来源' },
                        { info1: 'payRecipientId', info2: '是', info3: 'String', info4: '收款主体编码' },
                        ]
                },],
                R_params: [{
                  titleName: null,
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: 'paymentConfig', info2: '是', info3: 'JSONArray', info4: '支付配置信息列表' },
                  ]
                },{
                    titleName: 'paymentConfig',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'payCompayName', info2: '否', info3: 'String', info4: '支付客户端名称' },
                        { info1: 'clientEn', info2: '否', info3: 'Integer', info4: '支付客户端0微信支付，1支付宝支付' },
                        { info1: 'mchId', info2: '否', info3: 'String', info4: 'paymentChannel=2、4: 商户号，paymentChannel=3：商户id' },
                        { info1: 'appid', info2: '否', info3: 'String', info4: '\t\n' +
                            'paymentChannel=2：应用id，paymentChannel=4： appid，paymentChannel=3：对账用户' },
                        { info1: 'key', info2: '否', info3: 'String', info4: 'paymentChannel=2、4: 支付KEY，paymentChannel=3: 交易密钥，' },
                        { info1: 'extraProperty', info2: '否', info3: 'JSONObject', info4: '参考extraProperty参数说明' },
                        { info1: 'status', info2: '否', info3: 'Integer', info4: '0无效1有效' },
                        { info1: 'updateTime', info2: '否', info3: 'String', info4: '更新时间' },
                        { info1: 'paymentChannel', info2: '是', info3: 'Integer', info4: '支付渠道，0到账平台、1直接到账、2通联、3银联、4支付中间件' },
                        { info1: 'weixinAccountId', info2: '否', info3: 'Long', info4: '公众号id' },
                        ]
                },{
                    titleName: 'extraProperty',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'url', info2: '否', info3: 'String', info4: '请求链接 paymentChannel=4' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注 paymentChannel = 4' },
                        { info1: 'subMchId', info2: '否', info3: 'String', info4: '子商户号 paymentChannel=4' },
                        { info1: 'keyWechat', info2: '否', info3: 'String', info4: 'clientEn=0，paymentChannel=4、2 与key一致' },
                        { info1: 'mchIDWechat', info2: '否', info3: 'String', info4: 'clientEn=0，paymentChannel=4、2 与mchId一致' },
                        { info1: 'appIDWechat', info2: '否', info3: 'String', info4: 'clientEn=0，paymentChannel=4、2 与appid 一致' },
                        { info1: 'toaccount', info2: '否', info3: 'String', info4: 'clientEn =0， ydt ：对账平台，park： 直接到账，allinpay：通联支付， GNETE_PAY：银联，MIDDLE： 中间件，' },
                        { info1: 'login_pwd', info2: '否', info3: 'String', info4: '对账密码 paymentChannel=3' },
                        { info1: 'appId', info2: '否', info3: 'String', info4: '微信appId paymentChannel=3' },
                        { info1: 'appSercert', info2: '否', info3: 'String', info4: '微信appSercert paymentChannel=3' },
                        { info1: 'orgid', info2: '否', info3: 'String', info4: '集团号 paymentChannel=2' },
                        { info1: 'weixinMchId', info2: '否', info3: 'String', info4: '车场特约商号 paymentChannel=1' },
                        { info1: 'ydtMchId', info2: '否', info3: 'String', info4: '平台服务商号 paymentChannel=1' },
                        { info1: 'payee', info2: '否', info3: 'String', info4: 'ydt 对账平台账户，park 对账车场账户' },
                        { info1: 'keyAlipay', info2: '否', info3: 'String', info4: 'clientEn=1，paymentChannel=4 与key一致' },
                        { info1: 'mchIDAlipay', info2: '否', info3: 'String', info4: 'clientEn=1，paymentChannel=4、3 与mchId一致' },
                        { info1: 'appIDAlipay', info2: '否', info3: 'String', info4: 'clientEn=1，paymentChannel=4、3 与appid 一致' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/ydtUser/getPayChannelList.vue